import styled from "styled-components";
import {
  COLORS,
  TYPOGRAPHY,
  BREAKPOINTS
} from "../../containers/impact-report/constants";

export const HeroContainer = styled.div`
  width: 100%;
  padding-bottom: 32px;
  position: relative;
  background-color: ${COLORS.BG_COLOR};

  @media (min-width: ${BREAKPOINTS.MD}) {
    padding-bottom: 0;

    &::after {
      content: "";
      position: absolute;
      inset: 0;
      background-color: rgba(0, 0, 0, 0.3);
      pointer-events: none;
    }
  }
`;

export const HeroImage = styled.img`
  width: 100%;
  height: auto;
  display: block;

  @media (min-width: ${BREAKPOINTS.MD}) {
    height: 600px;
    object-fit: cover;
    object-position: center;
  }
`;

export const HeroTextContent = styled.div`
  padding: 40px 24px 30px;

  @media (min-width: ${BREAKPOINTS.MD}) {
    position: absolute;
    top: 50%;
    left: 24px;
    transform: translateY(-50%);
    background-color: transparent;
    padding: 0;
    max-width: 600px;
    text-align: left;
    z-index: 1;
  }
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;

  svg {
    --icon-fill: #1998d5;

    @media (min-width: ${BREAKPOINTS.MD}) {
      --icon-fill: ${COLORS.WHITE};
    }
  }
`;

export const LogoText = styled.span`
  ${TYPOGRAPHY.H1_MOBILE}
  color: ${COLORS.NEUTRAL_500};

  @media (min-width: ${BREAKPOINTS.MD}) {
    color: ${COLORS.WHITE};
  }
`;

export const Title = styled.h1`
  ${TYPOGRAPHY.H2_MOBILE}
  color: ${COLORS.NEUTRAL_500};
  margin: 0 0 16px 0;

  @media (min-width: ${BREAKPOINTS.MD}) {
    ${TYPOGRAPHY.HEADING_XLARGE_MEDIUM}
    color: ${COLORS.WHITE};
    margin: 0 0 24px 0;
  }
`;

export const Description = styled.p`
  ${TYPOGRAPHY.BODY_LARGE_LIGHT}
  color: ${COLORS.NEUTRAL_500};
  margin: 0;

  @media (min-width: ${BREAKPOINTS.MD}) {
    ${TYPOGRAPHY.P_DESKTOP}
    color: ${COLORS.WHITE};
  }
`;
